import PropTypes from 'prop-types';

export default {
	clientContext: PropTypes.shape({
		client: PropTypes.shape({
			user_tracking_id: PropTypes.string.isRequired,
			app_title: PropTypes.string.isRequired,
			app_package_name: PropTypes.string.isRequired,
			app_version_code: PropTypes.string.isRequired,
			app_version_name: PropTypes.string.isRequired,
		}),
		env: PropTypes.shape({
			platform_version: PropTypes.string.isRequired,
			make: PropTypes.string.isRequired,
			locale: PropTypes.string.isRequired,
			device_name: PropTypes.string.isRequired,
			platform: PropTypes.string.isRequired,
		}),
	}).isRequired,
	accessToken: PropTypes.string.isRequired,
	bankId: PropTypes.string,
};
